import { GIT_PROVIDERS } from 'common/constants/constants';

export const MAX_NUM_OF_REPOS_TO_FETCH = 500;

export const isCheckNumberOfReposistories = ({
  isFetchLargeRepos,
  sensor_id
}) => {
  return isFetchLargeRepos && sensor_id === GIT_PROVIDERS.GITHUB;
};
